export function havePermission(permissions = [], permission = {}) {
    let find = permissions.findIndex((v) => {
        if(v.Agency_Id === permission.Agency_Id && v.Obj_Code === permission.Obj_Code){
            return true;
        }
        return false;
    });
    if(find !== -1){
        return permissions[find]
    }
    return false
}

export function haveRole(permissions = [], permission = {}) {
    let find = permissions.findIndex((v) => {
        if(v.Obj_Code === permission.Obj_Code){
            return true;
        }
        return false;
    });
    if(find !== -1){
        return permissions[find]
    }
    return false
}